import { render, staticRenderFns } from "./ClientPortal.vue?vue&type=template&id=3580522d"
import script from "./ClientPortal.vue?vue&type=script&lang=ts"
export * from "./ClientPortal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3580522d')) {
      api.createRecord('3580522d', component.options)
    } else {
      api.reload('3580522d', component.options)
    }
    module.hot.accept("./ClientPortal.vue?vue&type=template&id=3580522d", function () {
      api.rerender('3580522d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/ClientPortal.vue"
export default component.exports